<template>
  <div class="hello">
    <div class="container-fluid px-md-4">
      <div class="jumbotron pt-3 pb-0 bg-white">
        <div class="row justify-content-between">
        <h2 class="text-left  ml-md-4">Identity Pools       
        </h2>     
        <i class="text-right pl-3 fas fa-sync-alt" @click="getDashboardData"></i>
        </div>
        <hr class="mt-2 mb-4" />
        <div class="row content ">

          <div
            class="col-lg-4 col-12  px-0  border rounded my-2"
            v-for="(identity,index) in chartData"
            :key="identity.id"
          >
            <h5 class="chart-title">{{identity.name}} 
              <i class="pl-4 fas fa-trash-alt" :name="identity.name" :id="identity.id" @click="remove"></i>
            </h5>

            <!-- 
            :title-text="identity.name"
            :title-position="'top'"
            :title-align="'center'"
            :title-padding-right=90 -->
           <chart v-if="identity.totalCount!=0"
            :ref="'chart' +index"
            :chart-area-background="''"
            :legend-visible="true"
            :legend-position="'bottom'"
            :legend-align="'center'"
            :legend-orientation="'horizontal'"
            :series-defaults-labels-visible="true"
            :series-defaults-labels-background="'transparent'"
            :series-defaults-labels-template="labelTemplate"
            :chart-area-margin=20
            :chart-area-margin-top=30
            :chart-area-width=330
            :chart-area-height=250
            :series="[identity]"
            :tooltip-visible="true"
            :theme="'sass'">
            </chart>  
            <chart v-else
            :ref="'chart' +index"
            :chart-area-background="''"
            :legend-visible="true"
            :legend-position="'bottom'"
            :legend-align="'center'"
            :legend-orientation="'horizontal'"
            :series-defaults-labels-visible="true"
            :series-defaults-labels-background="'transparent'"
            :series-defaults-labels-template="labelTemplate"
            :chart-area-margin=20
            :chart-area-width=330
            :chart-area-height=250
            :series="series"
            :tooltip-visible="true"
            :theme="'sass'">
          </chart> 

          </div>
        </div>
      </div>
    </div>
    <!-- <h4 class="text-white">User is authorized</h4>
    <button @click="addUser">Add User</button> |
    <button @click="logout">Logout</button> |
    <button @click="addTenant">Add Tenant</button> -->
    <!-- <div>{{values}}</div> -->
  </div>
</template>

<script>
import axios from "axios";
import { sampleData } from "./data.js";
import { oidcSettings } from "../services/store";
import { Chart } from '@progress/kendo-charts-vue-wrapper';
import '@progress/kendo-ui/js/kendo.dataviz.chart' ;

export default {
  name: "LandingPage", 
  components: {
        'chart': Chart
    },
  data() {
    return {
      values: "no data yet",
      services: [],
      dashboard: undefined,
      chartData:undefined,
      labelTemplate: '#= category # #= value #',
            series: [{
                type: 'pie',
                startAngle: 80,
                data: [{category:"No Data",value:100}],
            }]
    };
  },
  mounted:function(){
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    this.getDashboardData();
  },
  methods: {
    showSnackbar:function(message) {
      var x = document.getElementById("snackbar");
      x.className = "show";
      if(typeof message === 'string' || message instanceof String)
      x.innerHTML=message;
      else
      x.innerHTML="Request Failed";
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    },
    async remove(event) {
      if(confirm("Are you sure you want to delete Identity Pool?")){
      if(event.target.getAttribute("name").toLowerCase() == "Masterpool".toLowerCase())
      {
        this.showSnackbar("Default Identity Pool Can Not Be Deleted")
        return;
      }
      try {
        var identityPoolID=event.target.id;
        const response = await axios.delete(
          this.base_url + "IdentityPool/DeleteIdentityPool/"+identityPoolID ,
        );
        this.chartData = this.chartData.filter(
          (p) => p.id !== identityPoolID
        );
        this.$emit("refresh");
        console.log(this.identityPools);
      } catch (err) {
        console.log(err);
      }
      }
    },
    async getDashboardData() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetAllIdentityPoolData"
        );
        
        this.dashboard= response.data.result;
        this.chartData = this.getChartData(this.dashboard);
      } catch (err) {
        console.log(err);
      }
    },
  getChartData(dataItem){
    const chartData = [];
    dataItem.forEach(element => {
    var itemDetails = {};
    
    itemDetails.name = element.identityPoolName;
    itemDetails.id = element.identityPoolID;
    var totalCount = parseInt(element.userCount)+parseInt(element.clientCount)+parseInt(element.tenantCount);
    var userRatio = parseInt(element.userCount);
    var clientRatio = parseInt(element.clientCount);
    var tenantRatio = parseInt(element.tenantCount);
    itemDetails.data=[];
    itemDetails.data.unshift({category:"Users",value:userRatio},{category:"Clients",value:clientRatio},{category:"Tenants",value:tenantRatio})
    itemDetails.type='pie';
    itemDetails.totalCount=totalCount;
    itemDetails.startAngle= 150;
    chartData.unshift(itemDetails);
    });
    return chartData;
}
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart-title{
  background:#f5f6fa;
  border:1px solid #fff;
  border-radius:10px;
  padding:1rem;
  margin:1rem;
}
.fa-sync-alt{
  font-size: 20px;
}
.fas:hover{
  color:rgb(177, 22, 22);
  cursor: pointer;
}
.content {
  overflow: auto;
  height: 65vh;
}
.jumbotron {
  margin-bottom: 0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.card-header {
  background: #303f9f;
}

.card-body span {
  font-weight: 600;
  color: #303f9f;
}
</style>
